'use client'
import React from 'react'
import { MsalProvider } from '@azure/msal-react'
import { PublicClientApplication, RedirectRequest } from '@azure/msal-browser'
import { msalConfig } from '../msalConfigs'

type SessionProvider = {
    children: React.ReactNode
}

export const msalInstance = new PublicClientApplication(msalConfig)
export function SessionProvider({ children }: SessionProvider) {
    return <MsalProvider instance={msalInstance}>{children}</MsalProvider>
}
